import type { ItemMaster } from "../api/types.ts"

/**
 * 접수 라인의 화면 상태. 칸은 전부 문자열이다 — 사람이 지우는 중인 "" 를 0 으로 바꾸면
 * 커서가 튄다. 보낼 때만 숫자로 바꾼다.
 */
export type IntakeLine = {
  /** React key. 줄을 지워도 다른 줄의 상태가 섞이지 않게 한다. */
  key: number
  /** 마스터 id 또는 "" (직접 입력). */
  itemId: string
  /** 직접 입력일 때의 품명. 마스터를 골랐으면 서버가 마스터 이름을 복사한다. */
  description: string
  qty: string
}

let nextKey = 1

export function newIntakeLine(): IntakeLine {
  return { key: nextKey++, itemId: "", description: "", qty: "1" }
}

/**
 * 고르는 칸에 보여 줄 품명.
 *
 * 품목 마스터에는 한국어 품명과 영문 품명이 있다. 일본어로 보는 사람에게 한국어 이름은
 * 읽히지 않으므로 영문 품명을 보여 준다(세관 서류에 나가는 이름도 그쪽이다).
 */
export function masterLabel(master: ItemMaster, locale: string): string {
  return locale === "ja" ? master.nameEn : master.nameKo
}

/** 한 줄이 보낼 수 있는 모양인가 — 품목이 정해졌고 수량이 1 이상인가. */
export function lineIsValid(line: IntakeLine): boolean {
  const named = line.itemId !== "" || line.description.trim() !== ""
  return named && /^\d+$/.test(line.qty) && Number(line.qty) > 0
}

/** 접수 버튼을 누를 수 있는가. 한 줄 이상이어야 하고 모든 줄이 성해야 한다. */
export function linesAreValid(lines: readonly IntakeLine[]): boolean {
  return lines.length > 0 && lines.every(lineIsValid)
}

export type ApiIntakeLine = { itemId: number | null; description: string | null; qty: number }

/** 서버로 보낼 모양(`server/src/routes/cases.ts` 의 lineSchema). */
export function toApiLines(lines: readonly IntakeLine[]): ApiIntakeLine[] {
  return lines.map((line) => ({
    itemId: line.itemId === "" ? null : Number(line.itemId),
    description: line.itemId === "" ? line.description.trim() : null,
    qty: Number(line.qty),
  }))
}
